import styled from "styled-components";
import {error, secondary, success} from "../colors";

export const H1 = styled.h1`
  font-size: 28px;
  font-weight: bold;
  margin: 0 0 20px 0;

  @media only screen and (max-width: 767px) {
     font-size: 24px;
     margin-bottom: 14px;
  }
`;

export const H2 = styled.h1`
  font-size: 20px;
  font-weight: bold;
  margin: 0 0 20px 0;

  @media only screen and (max-width: 767px) {
     font-size: 16px;
     margin-bottom: 14px;
  }
`;

export const Paragraph = styled.p`
  margin-top: 0;
  font-size: 14px;
`;

export const PreFormattedParagraph = styled.pre`
  margin-top: 0;
  font-size: 14px;
  font-family: inherit;
  white-space: pre-wrap;
`

export const ListItem = styled.li`
  font-size: 14px;
  margin: 2px 0;
`;

export const Link = styled.a`
  color: black;
  text-decoration: none;
 :hover {
    color: ${({theme}) => theme.primary};
 }
`;

export const BoldParagraph = styled(Paragraph)`
  font-weight: bold;
`;

export const BoldSpan = styled.span`
  font-weight: bold;
`;

export const ItalicParagraph = styled(Paragraph)`
  font-style: italic;
`;

export const PrecisionParagraph = styled(Paragraph)`
  font-size: 12px;
`;

export const Label = styled.label`
  font-weight: bold;
  font-size: 12px;
  margin-bottom: 5px;
`;

export const Sublabel = styled(Label)`
  font-weight: normal;
  font-size: 12px;
  margin-bottom: 5px;
`;

export const PrimaryText = styled.span`
  color: ${({theme}) => theme.primary};
`;

export const SecondaryText = styled.span`
  color: ${secondary};
`;

export const SuccessText = styled.span`
  color: ${success};
`;

export const ReturnArrow = styled(SecondaryText)`
  display: inline-block;
  transform: scaleY(1.5);
  padding-bottom: 8px;
  margin-right: 5px;
  font-weight: 300;

  :after {
    content: '<'
  }
`;

export const ErrorMessage = styled(BoldParagraph)`
  color: ${error};
  font-size: 12px;
`;

export const ListTitle = styled(Paragraph)`
  margin-bottom: 8px;
`;

export const NoDataParagraph = styled(Paragraph)`
  font-size: 18px;
  color: gray;
  padding-top: 20px;
  align-self: center;
`;
